export default __webpack_public_path__ + "static/media/open-tasks.6cf675a5.png";